import PayrollAutopayrollExceededCreditLimitBanner from './PayrollAutopayrollExceededCreditLimitBanner';

export default PayrollAutopayrollExceededCreditLimitBanner;
